<template>
  <main class="page-operative page-operative-project page-operative-project-library-templates page-operative-project-library-templates-list d-flex flex-column h-100">
    <div class="flex-grow-1 container-fluid d-flex flex-column h-100">
      <div class="d-flex align-items-start justify-content-between flex-wrap flex-md-nowrap mb-5">
        <PageTitle class="mb-2 mb-md-0">Progetti</PageTitle>

        <app-router-link v-if="userCanEdit" class="btn btn-primary" :to="{ name: 'operative-company.projects.add' }">
          Aggiungi progetto
        </app-router-link>
      </div>

      <div class="flex-grow-1 d-flex flex-column h-100 overflow-auto">
        <LoadingDataLoader v-if="isLoadingData"></LoadingDataLoader>
        <ErrorOnLoadingDataFeedback v-else-if="errorLoadingData"></ErrorOnLoadingDataFeedback>
        <template v-else>
          <div class="row no-gutters justify-content-end align-items-center mb-3">
            <div class="col-auto mr-5">
              <BFormCheckbox v-model="showOptions.budgeted" class="no-select" :switch="true">
                Previsti
              </BFormCheckbox>
            </div>
            <div class="col-auto mr-5">
              <BFormCheckbox v-model="showOptions.accepted" class="no-select" :switch="true">
                Accettati
              </BFormCheckbox>
            </div>
            <div class="col-auto mr-5">
              <BFormCheckbox v-model="showOptions.started" class="no-select" :switch="true">
                Avviati
              </BFormCheckbox>
            </div>
            <div class="col-auto mr-5">
              <BFormCheckbox v-model="showOptions.completed" class="no-select" :switch="true">
                Conclusi
              </BFormCheckbox>
            </div>
            <div class="col-auto">
              <button type="button" class="btn btn-primary" @click.prevent="retrieveListData">Aggiorna lista</button>
            </div>
          </div>

          <ProjectsListTable v-if="results" class="report-texts-size" :templates="results" :edit-enabled="userIsAdmin || userIsContextCompanyConsultant || userIsContextCompanyOwner" @delete="removeProject" />
        </template>
      </div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';
import loadingDataMixin from '@/mixins/loadingData';
import confirmWithModalMixin from '@/libs/Confirm/mixins/confirmWithModal';
import { BFormCheckbox } from 'bootstrap-vue';

export default {
  name: 'page-operative-company-project-library-templates-list',
  mixins: [operativePageMixin, loadingDataMixin, confirmWithModalMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    ErrorOnLoadingDataFeedback: () => import('@/views/components/Operative/ErrorOnLoadingDataFeedback'),
    LoadingDataLoader: () => import('@/views/components/Operative/LoadingDataLoader'),
    ProjectsListTable: () => import('@/views/components/Operative/ListTable/ProjectsListTable'),
    AppRouterLink: () => import('@/views/components/Layout/AppRouterLink'),
    BFormCheckbox,
  },
  data () {
    return {
      data: null,
      results: null,

      showOptions: {
        budgeted: true,
        accepted: true,
        started: true,
        completed: false,
      },
    };
  },
  methods: {
    retrieveListData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();
      this.$api.listProjects(this.company?.id, this.showOptions)
        .then(res => {
          this.results = res?.data?.projects || [];
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
    removeProject (id) {
      this.confirm('Cancellare il progetto? L\'operazione è irreversibile', 'Ok', 'Annulla')
        .then(confirmed => {
          if (!confirmed) {
            return;
          }

          this.$api.deleteProject(this.company.id, id).then(() => this.retrieveListData()).catch(this.$log.error);
        })
      ;
    },
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        this.retrieveListData();
      },
    },
  },
};

</script>
